<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
.el-date-editor .el-range-separator{
  min-width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue